/*add case*/
import React, { Component } from "react";
import CaseEntries from "../CaseSelector/CaseEntries/CaseEntries";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
	requestPageOfAdminCases,
	searchSortAdminData
} from "./store/action";
import "../CaseSelector/CaseSelector.css";
import "./Admin.css";
import axios from "axios";
import { apiUri } from "../../config";
import Paginator from "../../hoc/Paginator/Paginator";
import { FaSearch, FaTimes } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";
import Modal from "react-responsive-modal";
import { NotificationManager } from "react-notifications";
import DatePicker from "react-datepicker";
import moment from "moment";
import { allowAlphaNumeric, onlyNumeric } from "../../util";

import "react-datepicker/dist/react-datepicker.css";

import Select from 'react-select';

const integerRegrex = /^[0-9]*$/;
const aphabetnumberRegex = /^[a-zA-Z0-9]*$/;
class CaseManagement extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
				searchValue: "",
				searchArray: [],
				currentCases: [],
				sortValue: "",
				sortOrder: "",
				searching: false,
				searchData: [],
				openAddModal: false,
				openImportModal: false,
				addCaseData: {
				fillingName: "",
				classPeriodStart: moment(),
				classPeriodEnd: "",
				nextTradingDay: "",
				fillingDate: "",
				classPeriodStart_UI: "",
				classPeriodEnd_UI: "",
				nextTradingDay_UI: "",
				fillingDate_UI: "",
				ticker: "",
				docketNotes:"",
				settlementValue:"",
				docketId: "",
				issCaseId: "",
				purchased: false,
				enabled: false,
				market: "",
				caseFile: "",
				identifier: "",
				sicCode: "",
				cik: "",
				fillingNameError: "",
				classPeriodStartError: "",
				classPeriodEndError: "",
				nextTradingDayError: "",
				fillingDateError: "",
				tickerError: "",
				docketIdError: "",
				issCaseIdError: "",
				sicCodeError: "",
				cikError: "",
				marketError: "",
				settlementValueError:"",
				caseFileError: "",
				indexListIdError: "",
				identifierError: ""
			},
			logsData: [],
			amendClaimsList: [],
			ruleTypeList: [],
			indexList:[],
			settlementStatusList:[],
			CSVcases:[]

		};
		this.handleClick = this.handleClick.bind(this);
		this.updateSearchValue = this.updateSearchValue.bind(this);
		this.goToCaseHandler = this.goToCaseHandler.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleSaveFileData = this.handleSaveFileData.bind(this);
		this.handleSaveStatus = this.handleSaveStatus.bind(this);
		this.handleClear = this.handleClear.bind(this);
		this.handleCreateCase = this.handleCreateCase.bind(this);
		this.handleCreateCancel = this.handleCreateCancel.bind(this);
		this.handleOnChange = this.handleOnChange.bind(this);
		this.importLogs = this.importLogs.bind(this);
		this.importLogsNew = this.importLogsNew.bind(this);
		this.runAdminPostUpdate = this.runAdminPostUpdate.bind(this);
		this.getLogs = this.getLogs.bind(this);
		this.DownloadCSV = this.DownloadCSV.bind(this);
	}

	importLogs = (data) => {
		let self = this;
		localStorage.removeItem("timestamp");
		axios
			.get(apiUri + "/cases/"+data)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					NotificationManager.success(json.data.statusMessage, "Success");
				} else {
					NotificationManager.error(json.data.statusMessage, "Failure");
				}
			})
			.catch(err => {
				console.log(err);
			});

		this.setState({ openImportModal: true });
		var tmLoc = new Date();
		let T2 = tmLoc.getTime() + tmLoc.getTimezoneOffset() * 60000;
		localStorage.setItem("timestamp", T2);
		axios
			.get(apiUri + "/admin/getLogs")
			.then(json => {
				if (json.data) {
					self.setState({ logsData: json.data.content });
				}
			})
			.catch(err => {
				console.log(err);
			});
	};

	importLogsNew = (data) => {
		let self = this;
		localStorage.removeItem("timestamp");

		this.setState({ openImportModal: true });
		var tmLoc = new Date();
		let T2 = tmLoc.getTime() + tmLoc.getTimezoneOffset() * 60000;
		localStorage.setItem("timestamp", T2);
		axios
			.get(apiUri + "/admin/getLogs")
			.then(json => {
				if (json.data) {
					self.setState({ logsData: json.data.content });
				}
			})
			.catch(err => {
				console.log(err);
			});
	};

	getLogs = () => { 
		let self = this;
		axios
			.get(apiUri + "/admin/getLogs") 
			.then(json => {
				if (json.data) {
					self.setState({ logsData: json.data.content });
				}
			})
			.catch(err => {
				console.log(err);
			});
	};

	runAdminPostUpdate = (data) => {
		axios
			.post(apiUri +'/admin/'+data, {})
			.then(res => {
				
				if (res.status && res.status >= 200 && res.status < 300) {
					NotificationManager.success(res.data.statusMessage, "Request Accepted");
				} else {
					NotificationManager.error(res.data.statusMessage, "Failure");
				}
				
			})
			.catch(err => {
				console.log(err);
			});
		this.importLogsNew(data);
	};

	goToCaseHandler = caseId => {
		this.props.history.push("/cases/" + caseId);
	};
	handleEdit = caseData => {
		if (caseData) {
		}
	};

	handleSaveFileData = (data, actionType, _onCloseModal) => {
	
		if (data) {
			let StartDate =
				new Date(data.classPeriodStart).getFullYear() +
				"-" +
				("0" + (new Date(data.classPeriodStart).getMonth() + 1)).slice(-2) +
				"-" +
				("0" + new Date(data.classPeriodStart).getDate()).slice(-2);
				let EndDate =
				new Date(data.classPeriodEnd).getFullYear() +
				"-" +
				("0" + (new Date(data.classPeriodEnd).getMonth() + 1)).slice(-2) +
				"-" +
				("0" + new Date(data.classPeriodEnd).getDate()).slice(-2);
				let FillingDate =
				new Date(data.fillingDate).getFullYear() +
				"-" +
				("0" + (new Date(data.fillingDate).getMonth() + 1)).slice(-2) +
				"-" +
				("0" + new Date(data.fillingDate).getDate()).slice(-2);

				let testDate = new Date(data.nextTradingDay).getFullYear();
				let NextDate = data.nextTradingDay && !isNaN(testDate ) ?
				new Date(data.nextTradingDay).getFullYear() +
				"-" +
				("0" + (new Date(data.nextTradingDay).getMonth() + 1)).slice(-2) +
				"-" +
				("0" + new Date(data.nextTradingDay).getDate()).slice(-2) : ""; 

			let obj = {
				caseId: data.caseId,
				docketId: data.docketId,
				issCaseId: data.issCaseId,
				symbol: data.ticker,
				caseName: data.fillingName,
				dateFiled: FillingDate,
				classPeriodStart: StartDate,
				classPeriodEnd: EndDate,
				nextTradingDay: NextDate,
				purchased: data.purchased,
				enabled: data.enabled,
				market: data.market,
				identifier: data.identifier,
				docketNotes:data.docketNotes,
				settlementValue:data.settlementValue,
				caseFile: data.caseFile,
				caseRuleTypeId: data.caseRuleTypeId,
				settlementStatusId:data.settlementStatusId,
				indexListId:data.indexListId,
				sicCode: data.sicCode,
				cik: data.cik,
				amendClaims: data.amendClaims,
				blockIssUpdates : data.blockIssUpdates,
				importStatus : !data.importStatus
			};
			
			let myUrl = "/cases/updateCase";
			if(actionType === "Duplicate") {
				myUrl = "/cases/createCase";
			}
			axios
				.post(apiUri + myUrl, obj)
				.then(json => {
					if (json.data && json.data.statusCode === 200) {
						this.props.requestPageOfAdminCases(
							this.props.currentPage,
							this.state.sortValue,
							this.state.sortOrder
						);
						NotificationManager.success(json.data.statusMessage, "Success");
						// _onCloseModal();
					} else {
						NotificationManager.error(json.data.statusMessage, "Failure");
					}
				})
				.catch(err => {
					console.log(err);
				});
		}
	};
	handleSaveStatus = data => {
		if (data) {
			let obj = {
				caseId: data.caseId,
				enabled: data.enabled
			};
			axios
			.post(apiUri + "/cases/updateEnabled", obj)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					this.props.requestPageOfAdminCases(
						this.props.currentPage,
						this.state.sortValue,
						this.state.sortOrder
					);
					NotificationManager.success(json.data.statusMessage, "Success");
				}
			})
			.catch(err => {
				console.log(err);
			});
		}
	};
	handleOnChange = (caseData, value, key) => {
		let state = this.state;
		this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
		if (key === "enabled") {
			if (value === "false") {
				state.addCaseData["enabled"] = true;
			} else {
				state.addCaseData["enabled"] = false;
			}
		} else if (
			key === "classPeriodStart" ||
			key === "classPeriodEnd" ||
			key === "nextTradingDay" ||
			key === "fillingDate"
		) {
			this.setState({ [key]: value, [key + "Error"]: "" });
			state.addCaseData[key] = new Date(value).getTime();
		} else {
			state.addCaseData[key] = value.value;
		}
		this.setState({ addCaseData: state.addCaseData });
	};
	handleSelectChange = (selectedOption) => {
		let state = this.state;
		this.setState({ "indexListId": selectedOption.value, "indexListIdError": "" });
		state.addCaseData["indexListId"] = selectedOption.value;
	};

	handleCreateCase = data => {
		console.log(this.state.addCaseData);
		let status = true;
		if (
			!this.state.addCaseData.fillingName ||
			this.state.addCaseData.fillingName.trim() === ""
		) {
			status = false;
			this.setState({
				fillingNameError: "Filing Name required!"
			});
		} else {
			this.setState({ fillingNameError: "" });
		}
		if (
			!this.state.addCaseData.classPeriodStart ||
			this.state.addCaseData.classPeriodStart === ""
		) {
			status = false;
			this.setState({
				classPeriodStartError: "Class Period Start Date required!"
			});
		} else {
			this.setState({ classPeriodStartError: "" });
		}

		if (
			!this.state.addCaseData.classPeriodEnd ||
			this.state.addCaseData.classPeriodEnd === ""
		) {
			status = false;
			this.setState({
				classPeriodEndError: "Class Period End Date required!"
			});
		} else {
			this.setState({ classPeriodEndError: "" });
		}

		if (
			this.state.addCaseData.nextTradingDay &&
			this.state.addCaseData.nextTradingDay.length > 0 &&
			isNaN(Date.parse(this.state.addCaseData.nextTradingDay) )
		) {
			status = false;
			this.setState({
				nextTradingDayError: "If next trading day is entered it must be a valid date!"
			});
		} else {
			this.setState({ nextTradingDayError: "" });
		}

		if (
			!this.state.addCaseData.fillingDate ||
			this.state.addCaseData.fillingDate === ""
		) {
			status = false;
			this.setState({
				fillingDateError: "Filing Date required!"
			});
		} else {
			this.setState({ fillingDateError: "" });
		}

		if (
			!this.state.addCaseData.ticker ||
			this.state.addCaseData.ticker.trim() === ""
		) {
			status = false;
			this.setState({
				tickerError: "Ticker required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.addCaseData.ticker)) {
				status = false;
				this.setState({
					tickerError: "Enter only alphanumeric characters!"
				});
			} else {
				this.setState({ tickerError: "" });
			}
		}

		if (
			!this.state.addCaseData.identifier ||
			this.state.addCaseData.identifier.trim() === ""
		) {
			status = false;
			this.setState({
				identifierError: "Identifier required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.addCaseData.identifier)) {
				status = false;
				this.setState({
					identifierError: "Enter only alphanumeric characters!"
				});
			} else {
				this.setState({ identifierError: "" });
			}
		}

		if (
			!this.state.addCaseData.docketId ||
			!this.state.addCaseData.docketId.match(/^\d{2,2}-[a-z]{2,2}-\d{1,5}$/)
		) {
			status = false;
			this.setState({
				docketIdError: "Valid docket number required! (YY-cv-#####)"
			});
		} else {
			this.setState({ docketIdError: "" });
		}		
		if (this.state.addCaseData.issCaseId != null &&
			this.state.addCaseData.issCaseId.toString().trim() !== "" &&
			!integerRegrex.test(this.state.addCaseData.issCaseId)
			
		) {
			status = false;
			this.setState({
				issCaseIdError: "If ISS Case Id is included, it must be an integer"
			});
		} else {
			this.setState({ issCaseIdError: "" });
		}

		if (
			!this.state.addCaseData.sicCode ||
			this.state.addCaseData.sicCode.trim() === ""
		) {
			status = false;
			this.setState({
				sicCodeError: "SIC Code required!"
			});
		} else {
			if (!integerRegrex.test(this.state.addCaseData.sicCode)) {
				status = false;
				this.setState({
					sicCodeError: "Enter only numbers"
				});
			} else {
				this.setState({ sicCodeError: "" });
			}
		}
		if (
			!this.state.addCaseData.cik ||
			this.state.addCaseData.cik.trim() === ""
		) {
			status = false;
			this.setState({
				cikError: "CIK required!"
			});
		} else {
			if (!integerRegrex.test(this.state.addCaseData.cik)) {
				status = false;
				this.setState({
					cikError: "Enter only numbers"
				});
			} else {
				this.setState({ cikError: "" });
			}
		}

		if (
			!this.state.addCaseData.market ||
			this.state.addCaseData.market.trim() === ""
		) {
			status = false;
			this.setState({
				marketError: "Market required!"
			});
		} else {
			this.setState({ marketError: "" });
		}
		/*
		if (
			!this.state.addCaseData.docketNotes ||
			this.state.addCaseData.docketNotes.trim() === ""
		) {
			status = false;
			this.setState({
			docketNotesError: "Market required!"
			});
		} else {
			this.setState({ docketNotesError: "" });
		}*/
		if ( this.state.addCaseData.settlementStatusId === 2 &&
			(!this.state.addCaseData.settlementValue ||
			isNaN(this.state.addCaseData.settlementValue))
		) {
			status = false;
			this.setState({
				settlementValueError: "Settlement Value required!"
			});
		} else {
			this.setState({ settlementValueError: "" });
		}

		if (!this.state.addCaseData.indexListId ||
			isNaN(this.state.addCaseData.indexListId)
		) {
			status = false;
			this.setState({
				indexListIdError: "Industry Index required!"
			});
		} else {
			this.setState({ indexListIdError: "" });
		}
	/*
		if (!this.state.addCaseData.amendClaims ||
			isNaN(this.state.addCaseData.amendClaims)
		) {
			status = false;
			this.setState({
			amendClaimsError: "Claim Life Cycle must be selected!"
			});
		} else {
			this.setState({ amendClaimsError: "" });
		}    
	*/
		if (
			!this.state.addCaseData.caseFile ||
			this.state.addCaseData.caseFile.trim() === ""
		) {
			status = false;
			this.setState({
				caseFileError: "Case File required!"
			});
		} else {
			this.setState({ caseFileError: "" });
		}
		
		if (status) {
			if (data) {
				let StartDate =
					new Date(data.classPeriodStart).getFullYear() +
					"-" +
					("0" + (new Date(data.classPeriodStart).getMonth() + 1)).slice(-2) +
					"-" +
					("0" + new Date(data.classPeriodStart).getDate()).slice(-2);
				let EndDate =
					new Date(data.classPeriodEnd).getFullYear() +
					"-" +
					("0" + (new Date(data.classPeriodEnd).getMonth() + 1)).slice(-2) +
					"-" +
					("0" + new Date(data.classPeriodEnd).getDate()).slice(-2);
				let FillingDate =
					new Date(data.fillingDate).getFullYear() +
					"-" +
					("0" + (new Date(data.fillingDate).getMonth() + 1)).slice(-2) +
					"-" +
					("0" + new Date(data.fillingDate).getDate()).slice(-2);
				let testDate = new Date(data.nextTradingDay).getFullYear();
				let NextDate = data.nextTradingDay && !isNaN(testDate) ?
					new Date(data.nextTradingDay).getFullYear() +
					"-" +
					("0" + (new Date(data.nextTradingDay).getMonth() + 1)).slice(-2) +
					"-" +
					("0" + new Date(data.nextTradingDay).getDate()).slice(-2) : ""; 
					
				let obj = {
					caseId: data.caseId,
					docketId: data.docketId,
					issCaseId: data.issCaseId,
					symbol: data.ticker,
					identifier: data.identifier,
					caseName: data.fillingName,
					dateFiled: FillingDate,
					classPeriodStart: StartDate,
					classPeriodEnd: EndDate,
					nextTradingDay: NextDate,
					purchased: data.purchased,
					enabled: data.enabled,
					sicCode: data.sicCode,
					cik: data.cik,
					market: data.market,
					docketNotes:data.docketNotes,
					settlementValue:data.settlementValue,
					caseRuleTypeId: data.caseRuleTypeId? data.caseRuleTypeId : 1,
					settlementStatusId:data.settlementStatusId? data.settlementStatusId : 1,
					indexListId: data.indexListId ? data.indexListId : 1,
					caseFile: data.caseFile,
					amendClaims: data.amendClaims ? data.amendClaims : 1
				};

				axios
					.post(apiUri + "/cases/createCase", obj)
					.then(json => {
						if (json.data && json.data.statusCode === 200) {
							this.props.requestPageOfAdminCases(
								this.props.currentPage,
								this.state.sortValue,
								this.state.sortOrder
							);
							NotificationManager.success(json.data.statusMessage, "Success");
							this.setState({ openAddModal: false, addCaseData: {} });
						} else if (json.data && json.data.statusCode === 400) {
							NotificationManager.error(json.data.statusMessage, "Failure");
						}
					})
					.catch(err => {
						console.log(err);
					});
			}
		} else {
			return false;
		}
	};

	onCloseModal = () => {
		this.setState({ open: false, openAddModal: false });
		this.resetErrorStat();
	};

	resetErrorStat = () => {
		this.setState({
			fillingNameError: "",
			classPeriodStartError: "",
			classPeriodEndError: "",
			nextTradingDayError: "",
			fillingDateError: "",
			tickerError: "",
			docketIdError: "",
			issCaseIdError: "",
			sicCodeError: "",
			cikError: "",
			marketError: "",
			docketNotesError:"",
			settlementValueError:"",
			caseFileError: "",
			indexListIdError: "",
			identifierError: ""
		});
	};

	oncloseimportModal = () => {
		this.setState({ open: false, openImportModal: false, logsData: [] });
		localStorage.removeItem("timestamp");
	};

	handleSorting = (key, order) => {
		this.setState({ sortValue: key, sortOrder: order });
		let obj = {
			sortValue: key,
			sortOrder: order
		};
		localStorage.setItem("sortParams", JSON.stringify(obj));
		this.props.searchSortAdminData(0, key, order);
	};
	
	componentDidMount() {
	 
		let page = this.props.currentPage;
		this.props.requestPageOfAdminCases(
			page,
			this.state.sortValue,
			this.state.sortOrder
		);
		/*
		let check = localStorage.getItem('detailsPageUrl');
		if (check != null) {
			let checkDetailsPage = JSON.parse(localStorage.getItem('detailsPageUrl'));
			this.props.history.push(checkDetailsPage);
		}
		*/
	};

	updateSearchValue(evt) {
		this.setState({ searchValue: evt.target.value });
	};

	handleClick() {
		localStorage.setItem("searchValue", JSON.stringify(this.state.searchValue));
		sessionStorage.setItem('tempSearchValue',this.state.searchValue)
		var obj = JSON.parse(localStorage.getItem("sortParams"))
		const {sortValue='', sortOrder=''} = obj || {};
		this.setState({ sortValue, sortOrder });
		this.props.searchSortAdminData(0, sortValue, sortOrder);
	};

	handleClear() {
		this.setState({ searchValue: "" });
		localStorage.removeItem("sortParams");
		this.setState({sortOrder:'',sortValue:''})
		localStorage.removeItem("searchValue");
		sessionStorage.removeItem('tempSearchValue')
		this.props.searchSortAdminData(0);
	};

	handleCreateCancel() {
		this.setState({ openAddModal: false, addCaseData: {} });
		this.resetErrorStat();
	};

	keyPress(e) {
		if (e.keyCode === 13 || e.keyCode === 10) {
			this.handleClick();
		}
	};

	getAmendClaimsList() {
		axios
			.get(apiUri + "/cases/amendClaims")
			.then(res => {
				this.setState({
					amendClaimsList: res.data.content
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	getRuleType() {
		axios
			.get(apiUri + "/cases/ruleType")
			.then(res => {
				this.setState({
					ruleTypeList: res.data.content
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	getIndexList() {
		axios
			.get(apiUri + "/cases/getIndexList")
			.then(res => {
				this.setState({
					indexList: res.data['content']
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	getSettlementStatus() {
		axios
			.get(apiUri + "/cases/settlementStatus")
			.then(res => {
				this.setState({
					settlementStatusList: res.data.content
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	openAddCaseModel = () => {
		this.setState({ openAddModal: true, addCaseData: {} });
		if(!this.state.amendClaimsList || this.state.amendClaimsList.length === 0) {
			this.getAmendClaimsList();
		}
		if(!this.state.ruleTypeList || this.state.ruleTypeList.length === 0) {
			this.getRuleType();
		}
		if(!this.state.settlementStatusList || this.state.settlementStatusList.length === 0) {
			this.getSettlementStatus();
		}
		if(!this.state.indexList || this.state.indexList.length === 0) {
			this.getIndexList();
		}
	};

	DownloadCSV=()=> {
		axios.get(apiUri + "/admin/getCsv ")
		.then(json => {
			getCSVFile(json.data.content)     
		})
		.catch(err => {
			console.log(err)
		})
		var getCSVFile = function (responseData) {
			var CSVFinalContent = '';
			var CSVFormattedData = [['CASEFILE',
							'CASENAME',
							'CLASS PERIOD START DATE',
							'CLASS PERIOD END DATE',
							'NEXT TRADING DAY',
							'FILING DATE',
							'TICKER',
							'DOCKET NUMBER',
							'SICCODE',
							'EXCHANGE',
							'TYPE',
							'SETTLEMENT STATUS',
							'SETTLEMENT VALUE',
							'CLAIM LIFE CYCLE',
							'SAR CASE ID',
							'ISS CASE ID',
							'EVENTS'
							]];
			var getDateForm= function (timestamp) {
				var date = new Date(timestamp);
				var year = date.getUTCFullYear();
				var month = (1 + date.getUTCMonth()).toString().padStart(2, "0");
				var day = date
				.getUTCDate()
				.toString()
				.padStart(2, "0");
				return month + "-" + day + "-" + year;
			}

			for(let item = 0;item<responseData.length;item++) {

				CSVFormattedData.push([
					responseData[item].caseFile,
					responseData[item].caseName.replace(/,/g," "),
					getDateForm(responseData[item].classPeriodStart),
					getDateForm(responseData[item].classPeriodEnd),
					getDateForm(responseData[item].nextTradingDay),
					getDateForm(responseData[item].dateFiled),
					responseData[item].ticker,
					responseData[item].docketNumber,
					responseData[item].sicCode,
					responseData[item].exchange,
					responseData[item].type,
					responseData[item].settlementStatus,
					responseData[item].settlementValue,
					responseData[item].claimLifeCycle,
					responseData[item].caseId,
					responseData[item].issCaseId,
					responseData[item].events.replace(/,/g, ' | ')]);
			}
			var processRow = function (row) {
				var finalVal = '';
				for (var j = 0; j < row.length; j++) {
					var innerValue = row[j] === null ? '' : row[j].toString();
					if (row[j] instanceof Date) {
						innerValue = row[j].toLocaleString();
					};
					var result = innerValue.replace(/"/g, '""');
					if (result.search(/("|,|\n)/g) >= 0)
						result = '"' + result + '"';
					if (j > 0)
						finalVal += ',';
					finalVal += result;
				}
				return finalVal + '\n';
			};
			for (var i = 0; i < CSVFormattedData.length; i++) {
				CSVFinalContent += processRow(CSVFormattedData[i]);
			}

			var today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0');
			var yyyy = today.getFullYear();
			today = yyyy+''+mm+''+dd ;
			var blob = new Blob([CSVFinalContent], { type: 'text/csv;charset=utf-8;' });
			var link = document.createElement("a");
			if (link.download !== undefined) { 
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", "cases"+today+".csv");
				link.style.visibility = 'hidden';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		} 
	};

	componentDidUpdate() {
		window.onpopstate  = (e) => {
			e.preventDefault();
			var tempSearchValue = sessionStorage.getItem('tempSearchValue');
			if(tempSearchValue) {
				setTimeout(()=>{
					localStorage.setItem("searchValue", JSON.stringify(tempSearchValue));
					this.props.searchSortAdminData(this.props.currentPage);
				 },100)
				
				this.setState({ searchValue: tempSearchValue })
				 
			}
			var obj = JSON.parse(localStorage.getItem("sortParams"));
			if(obj) {
			
				this.setState({
					sortValue:obj.sortValue,
					sortOrder:obj.sortOrder
				})
		//.setItem("sortParams", JSON.stringify(obj));
		
				setTimeout(()=> {
					this.props.searchSortAdminData(this.props.currentPage, obj.sortValue, obj.sortOrder);
				},200) 		 
			}
		}
	};

	render() {

		let state = this.state;
		return (
			<React.Fragment>
			<div
				style={{ display: "flex", justifyContent: "space-between" }}
				className={"CaseManagementTitle"}
			>
				<span>SCA Database Management</span>
				<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					width: "180"
				}}
				>
				<div
					style={{
					position: "relative",
					width: "207px",
					height: "29px",
					top: "-1px",
					backgroundColor: "#83bed3",
					border: "1px solid rgb(90, 154, 176)",
					borderRadius: "14.5px"
					}}
				>
					<input
					id="search"
					type="text"
					className="searchBox"
					onKeyDown={e => this.keyPress(e)}
					value={this.state.searchValue}
					placeholder="Search"
					onChange={this.updateSearchValue}
					/>
					{this.state.searchValue && (
					<span className="clearIcon" onClick={this.handleClear}>
						x
					</span>
					)}
					<FaSearch className="searchBtn" onClick={this.handleClick} />
				</div>
				&nbsp;
				<button
					className="btn btnS"
					onClick={() => this.openAddCaseModel()}
				>
					Add
				</button>
				&nbsp;
				<button
					className="btn btnS"
					onClick={() => {
					this.runAdminPostUpdate('runImporter');
					}}
				>
					Import
				</button>
				&nbsp;
				<button
					className="btn btnS"
					onClick={() => {
					this.runAdminPostUpdate('importSettlement');
					}}
				>
					Settlement
				</button>
				&nbsp;
				<button
					className="btn btnS"
					onClick={() => {
					this.runAdminPostUpdate('runCaseUpdate');
					}}
				>
					Case Update
				</button>
				</div>
			</div>
			{this.props.currentCases.length > 0 ? (
				<CaseEntries
				cases={this.props.currentCases}
				sortValue={this.state.sortValue}
				sortOrder={this.state.sortOrder}
				goToCaseHandler={this.goToCaseHandler}
				handleEdit={this.handleEdit}
				handleDelete={this.handleDelete}
				handleSaveFileData={this.handleSaveFileData}
				handleSaveStatus={this.handleSaveStatus}
				handleSorting={this.handleSorting}
				/>
			) : (
				<div className="widthfull">
				<table className="widthfull">
					<tbody>
					<tr>
						<td className="norecords">
						<span>Loading ...</span>
						</td>
					</tr>
					</tbody>
				</table>
				</div>
			)}
			<button
					style={{marginTop:5}}
					className="btn btnS"
					onClick={() => this.DownloadCSV()}
				>
					Download CSV
				</button>
			{this.props.currentCases.length > 0 ? (
				<Paginator
				name={"case-selector"}
				totalPages={this.props.totalPages}
				currentPage={this.props.currentPage}
				setPage={(pageNumber)=>this.props.searchSortAdminData(pageNumber, this.state.sortValue, this.state.sortOrder)}
				/>
			) : (
				""
			)}

			<Modal
				open={this.state.openAddModal}
				onClose={this.onCloseModal}
				focusTrapped={true}
			>
				<div className="ModalWindow modaladd">
				<FaTimes className="closeicon" onClick={this.onCloseModal} />
				<h3 className="modalHeading">Add case</h3>
				<div className="NavDivider"></div>
				<table>
					<tbody>
					<tr>
						<td className="modalTd">Filing Name</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							name="fillingName"
							className="searchBox2"
							value={state.addCaseData.fillingName}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"fillingName"
							);
							}}
							required
						/>
						<span id="error-style">{this.state.fillingNameError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Class Period Start Date</td>
						<td style={{ paddingTop: 16 }}>
						<DatePicker
							className="searchBox2"
							selected={state.addCaseData.classPeriodStart}
							onChange={evt =>
							this.handleOnChange(
								state.addCaseData,
								evt,
								"classPeriodStart"
							)
							}
							dateFormat="yyyy-MM-dd"
						/>
						<span id="error-style">
							{this.state.classPeriodStartError}
						</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Class Period End Date</td>
						<td style={{ paddingTop: 16 }}>
						<DatePicker
							className="searchBox2"
							selected={state.addCaseData.classPeriodEnd}
							onChange={evt =>
							this.handleOnChange(
								state.addCaseData,
								evt,
								"classPeriodEnd"
							)
							}
							dateFormat="yyyy-MM-dd"
						/>
						<span id="error-style">
							{this.state.classPeriodEndError}
						</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Next Trading Day</td>
						<td style={{ paddingTop: 16 }}>
						<DatePicker
							className="searchBox2"
							selected={state.addCaseData.nextTradingDay}
							onChange={evt =>
							this.handleOnChange(
								state.addCaseData,
								evt,
								"nextTradingDay"
							)
							}
							dateFormat="yyyy-MM-dd"
						/>
						<span id="error-style">
							{this.state.nextTradingDayError}
						</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Filing Date</td>
						<td style={{ paddingTop: 16 }}>
						<DatePicker
							className="searchBox2"
							selected={state.addCaseData.fillingDate}
							onChange={evt =>
							this.handleOnChange(
								state.addCaseData,
								evt,
								"fillingDate"
							)
							}
							dateFormat="yyyy-MM-dd"
						/>
						<span id="error-style">{this.state.fillingDateError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Ticker:</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="ticker"
							value={state.addCaseData.ticker || ""}
							onKeyPress={$event => allowAlphaNumeric($event)}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"ticker"
							);
							}}
						/>
						<span id="error-style">{this.state.tickerError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">CapIQ Identifier:</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="identifier"
							value={state.addCaseData.identifier || ""}
							onKeyPress={$event => allowAlphaNumeric($event)}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"identifier"
							);
							}}
						/>
						<span id="error-style">{this.state.identifierError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Docket Number</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="docketId"
							value={state.addCaseData.docketId}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"docketId"
							);
							}}
						/>
						<span id="error-style">{this.state.docketIdError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">ISS Case ID</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="issCaseId"
							value={state.addCaseData.issCaseId}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"issCaseId"
							);
							}}
						/>
						<span id="error-style">{this.state.issCaseIdError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">SIC Code</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="sicCode"
							onKeyPress={$event => onlyNumeric($event)}
							value={state.addCaseData.sicCode || ""}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"sicCode"
							);
							}}
						/>
						<span id="error-style">{this.state.sicCodeError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">CIK Code</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="cik"
							onKeyPress={$event => onlyNumeric($event)}
							value={state.addCaseData.cik || ""}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"cik"
							);
							}}
						/>
						<span id="error-style">{this.state.cikError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Market</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="market"
							value={state.addCaseData.market}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"market"
							);
							}}
						/>
						<span id="error-style">{this.state.marketError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Docket Notes:</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="docketNotes"
							value={state.addCaseData.docketNotes}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"docketNotes"
							);
							}}
						/>
						<span id="error-style">{this.state.docketNotesError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Settlement Value</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="number"
							className="searchBox2"
							name="settlementValue"
							value={state.addCaseData.settlementValue}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"settlementValue"
							);
							}}
						/>
						<span id="error-style">{this.state.settlementValueError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Case File</td>
						<td style={{ paddingTop: 16 }}>
						<input
							type="text"
							className="searchBox2"
							name="caseFile"
							value={state.addCaseData.caseFile}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"caseFile"
							);
							}}
						/>
						<span id="error-style">{this.state.caseFileError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Settlement Status</td>
						<td style={{ paddingTop: 16 }}>
						<select
							className="amendSelect"
							name="settlementStatus"
							value={
							state.addCaseData.settlementStatusId
								? state.addCaseData.settlementStatusId
								: 1
							}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"settlementStatusId"
							);
							}}
						>
							{this.state.settlementStatusList.map(res => {
								return (
								<option key={res.id} value={res.id}>
									{res.status}
								</option>
								);
							})}
						</select>
						</td>
					</tr>
					
					<tr>
						<td className="modalTd">Type</td>
						<td style={{ paddingTop: 16 }}>
						<select
							className="amendSelect"
							name="type"
							value={
							state.addCaseData.caseRuleTypeId
								? state.addCaseData.caseRuleTypeId
								: 1
							}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"caseRuleTypeId"
							);
							}}
						>
							{this.state.ruleTypeList.map(res => {
							return (
								<option key={res.id} value={res.id}>
								{res.caseRuleType}
								</option>
							);
							})}
						</select>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Claim Life Cycle</td>
						<td style={{ paddingTop: 16 }}>
						<select
							className="amendSelect"
							name="amendSelect"
							value={
							state.addCaseData.amendClaims
								? state.addCaseData.amendClaims
								: 1
							}
							placeholder=""
							onChange={evt => {
							this.handleOnChange(
								state.addCaseData,
								evt.target,
								"amendClaims"
							);
							}}
						>
							{this.state.amendClaimsList.map(res => {
							return (
								<option key={res.id} value={res.id}>
								{res.claimType}
								</option>
							);
							})}
						</select>
						<span id="error-style">{this.state.amendClaimsError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd">Industry Index </td>
						<td
						style={{ paddingTop: 16, zIndex: 1, width: "60%", color: "black" }}
						className="relativePos"
						>
						<Select
							style={{ width: "100%", zIndex: 100, color: "black" }}
							width="100%"
							name="indexListId"
							defaultValue=""
							placeholder="Select An Index"
							onChange={this.handleSelectChange}
							options={state.indexList}
						/> 
						<span id="error-style">{this.state.indexListIdError}</span>
						</td>
					</tr>
					<tr>
						<td className="modalTd"></td>
					</tr>

					</tbody>
				</table>
				<div className="btnHolder">
					<button
					className="btn btnS"
					onClick={evt => {
						this.handleCreateCase(state.addCaseData);
					}}
					>
					Save
					</button>
					&nbsp; &nbsp;
					<button
					className="btn btnC"
					onClick={evt => {
						this.handleCreateCancel();
					}}
					>
					Cancel
					</button>
				</div>
				</div>
			</Modal>

			<Modal
				open={this.state.openImportModal}
				onClose={this.oncloseimportModal}
			>
				<input
				type="text"
				value=""
				style={{
					visibility: "visible",
					height: "0px",
					width: "0px",
					opacity: 0
				}}
				/>
				<div className="ModalWindow Modalimport">
				<table>
					<tbody>
					<tr>
						<td width="95%">
						<h3 className="modalHeading">Importer logs</h3>
						</td>
						<td width="5%">
						<FiRefreshCcw
							className="refreshicon"
							onClick={this.getLogs}
						/>
						</td>
						<td width="5%">
						<FaTimes
							className="closeiconLog"
							onClick={this.oncloseimportModal}
						/>
						</td>
					</tr>
					</tbody>
				</table>
				<div className="ModalDivider"></div>
				<div className="logsBlock">
					{this.state.logsData &&
					this.state.logsData.map(logs => <div>{logs}</div>)}
				</div>
				</div>
			</Modal>
			</React.Fragment>
		);
	}
};

const mapStateToProps = state => {
	return {
		currentCases: state.cases.currentCases,
		currentPage: state.cases.currentPage,
		totalCases: state.cases.totalCases,
		totalPages: state.cases.totalPages
	};
};

const mapDispatchToProps = dispatch => {
	return {
		requestPageOfAdminCases: (page, sortValue, sortOrder) =>
			dispatch(requestPageOfAdminCases(page, sortValue, sortOrder)),
		searchSortAdminData: (currentPage, sortValue, sortOrder) =>
			dispatch(searchSortAdminData(currentPage, sortValue, sortOrder)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(CaseManagement));



// WEBPACK FOOTER //
// ./src/components/Admin/CaseManagement.js